<template lang="html">
  <div>
    <div class="mt-5">
      <Navbar/>
    </div>
    <div class="CSChatThai hidden-sm-and-down">
      <v-layout id="about" column wrap align-center dark>
      <v-flex xs12 sm4 class="my-2">
        <div class="text-xs-center">
          <h1 style="margin-top:5vw" class="display-2 CSChatThai">เกี่ยวกับ OneChat Bot</h1>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card-title primary-title >
          <div class="headline CSChatThai" style="margin:30px; text-align: justify;">&emsp;&emsp;&emsp;&emsp;OneChat Bot เป็นหนึ่งในบริการของ One Chat ที่ให้บริการตอบกลับข้อความอัตโนมัติ สามารถใช้บริการนี้ได้ผ่านทางหน้าเว็บหรือผ่านทาง API ได้ การตอบกลับข้อความอัตโนมัติ เป็นได้ทั้งข้อความที่เป็นตัวอักษร ไฟล์ และรูปภาพ
          </div>
          </v-card-title>
          <!-- <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container> -->
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row>
        <img src="/static/image/chatbot5.png" style="height: 40vh;" >
        <img src="/static/image/chatbot4.png" style="height: 40vh; margin-left: 2vw;" >
      </v-layout>
    </div>
    <div class="CSChatThai hidden-md-and-up">
      <v-layout id="aboutmo" column wrap align-center>
      <v-flex xs12 sm4 class="my-2">
        <div class="text-xs-center">
          <h1 style="margin-top:5vw;font-size:25px !important;" class="display-2 CSChatThai">เกี่ยวกับ One Chat</h1>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card-title primary-title >
          <!-- <div class="headline CSChatThai" style="margin:10px !important; font-size:16px !important; text-align: justify;">&emsp;&emsp;&emsp;&emsp;<strong>One Chat</strong> เป็นแอพลิเคชั่นหนึ่งในตระกูลของ <strong><a href="https://one.th/" target="_blank">One Platform</a></strong> ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้ ซึ่ง One Chat สามารถส่งข้อความ, ไฟล์, รูปภาพ และยังมีฟังก์ชันอื่น ๆ อีกมากมาย ปัจจุบันสามารถใช้ One Chat ได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS) ที่สำคัญ One Chat ยังเชื่อมต่อกับ <strong><a href="https://mail.one.th/" target="_blank">One Mail</a></strong> ที่ให้บริการฟรีอีเมล, <strong><a href="https://box.one.th/login" target="_blank">One Box</a></strong> ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล และแอพลิเคชั่นอื่นๆ ในตระกูล One Platform อีกด้วย </div> -->
          <div class="headline CSChatThai" style="margin:30px; text-align: justify;">&emsp;&emsp;&emsp;&emsp;OneChat Bot เป็นหนึ่งในบริการของ One Chat ที่ให้บริการตอบกลับข้อความอัตโนมัติ สามารถใช้บริการนี้ได้ผ่านทางหน้าเว็บหรือผ่านทาง API ได้ การตอบกลับข้อความอัตโนมัติ เป็นได้ทั้งข้อความที่เป็นตัวอักษร ไฟล์ และรูปภาพ
          </div>
          </v-card-title>
          <!-- <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container> -->
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center column>
        <img src="/static/image/chatbot5.png" style="height: 40vh;" >
        <img src="/static/image/chatbot4.png" style="height: 40vh; margin-top: 2vw;" >
      </v-layout>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
export default {
  components: {
    Navbar
  }
}
</script>

<style lang="css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
a:link {
  text-decoration: none !important;
  /*color: black !important;*/
}

a:visited {
  /*color: black !important;*/
  text-decoration: underline !important;
}

a:hover {
  color: black !important;
  text-decoration: underline !important;
  /*color: #000000;
  border-bottom: 2px dashed #dd0000;*/
}

a:active {
  /*color: black !important;*/
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/AboutUs.vue